import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
import VideoModal from "../../../components/base/video-modal";
Swiper.use([Navigation, Pagination]);

export default class PageModule {
    constructor() {
        this.initPublicationVideoModal();
        this.initPublicationSliders();
    }

    initPublicationVideoModal() {
        const videoModal = new VideoModal({ id: 'publication-video'});
    }

    initPublicationSliders() {
        const $sliders = document.querySelectorAll('.publication-group_slider');

        if (!$sliders.length) return;

        $sliders.forEach(($slider) => {
            const $container = $slider.querySelector('.swiper-container');
            const $slides = $slider.querySelectorAll('.swiper-slide');

            if (!$slides.length) return;

            const config = {
                init: false,
                navigation: {
                    nextEl: $slider.querySelector('.swiper-nav.-next'),
                    prevEl: $slider.querySelector('.swiper-nav.-prev')
                },
                pagination: {
                    el: $slider.querySelector('.swiper-bullets'),
                    type: 'bullets',
                    clickable: true
                },
                slidesPerView: 3,
                spaceBetween: 30,
                breakpoints: {
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    600: {
                        spaceBetween: 30,
                        slidesPerView: 1
                    },
                    500: {
                        spaceBetween: 15,
                        slidesPerView: 1
                    }
                }
            };

            const swiper = new Swiper($container, config);

            swiper.on('init', function () {
                const $bullets = swiper.pagination.bullets;

                if ($bullets.length > 1) {
                    $slider.classList.add('-pagination');
                }
            });

            swiper.init();
        });
    }
}